const Search = () => (
    <svg
        width='17'
        height='18'
        viewBox='0 0 17 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            opacity='0.5'
            d='M16.6658 15.7577L13.6756 12.7583C16.1809 9.5968 15.696 4.97615 12.5442 2.46317C9.39233 -0.0498093 4.7858 0.517638 2.28049 3.59807C-0.224811 6.75956 0.340903 11.3802 3.41192 13.8932C6.07886 16.0008 9.87723 16.0008 12.5442 13.8932L15.5344 16.8926C15.8576 17.2168 16.3425 17.2168 16.6658 16.8926C16.9891 16.5683 16.9891 16.0819 16.6658 15.7577ZM8.01845 13.8932C4.86662 13.8932 2.36131 11.3802 2.36131 8.21871C2.36131 5.05722 4.86662 2.54424 8.01845 2.54424C11.1703 2.54424 13.6756 5.05722 13.6756 8.21871C13.6756 11.3802 11.1703 13.8932 8.01845 13.8932Z'
            fill='white'
        />
    </svg>
);

export default Search;
